import { render, staticRenderFns } from "./companyCheck1.vue?vue&type=template&id=1b6d64ec&scoped=true"
import script from "./companyCheck1.vue?vue&type=script&lang=js"
export * from "./companyCheck1.vue?vue&type=script&lang=js"
import style0 from "./companyCheck1.vue?vue&type=style&index=0&id=1b6d64ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d64ec",
  null
  
)

export default component.exports